import script from "./PMPStep6Enviado.vue?vue&type=script&setup=true&lang=js"
export * from "./PMPStep6Enviado.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__